import { detectDurableObjectClasses, detectDurableObjectClassesInFiles, resolvePlaygroundEntry } from "@workerstation/shared";
/** The native configuration body is retained; its library URI is owned by the project. */
export function editorWorkerConfiguration(files: Readonly<Record<string, string>>): string {
  const entry = resolvePlaygroundEntry(files);
  const doClasses = detectDurableObjectClassesInFiles(files);
  const durableUnion = doClasses.length === 0
    ? "never"
    : doClasses.map((name: string) => JSON.stringify(name)).join(" | ");
  // worker-configuration.d.ts lives at file:/// so imports are "./src/..."
  const toImportPath = (path: string) => `./${path.replace(/^\.\//, "")}`;
  // Include every module that exports a DO class in mainModule so Exports
  // keys exist even when DOs live outside the entry file.
  const modulesForMain = new Set<string>();
  if (entry)
    modulesForMain.add(entry);
  for (const [path, contents] of Object.entries(files)) {
    if (typeof contents === "string" &&
      detectDurableObjectClasses(contents).length > 0) {
      modulesForMain.add(path);
    }
  }
  const mainModuleType = modulesForMain.size > 0
    ? [...modulesForMain]
      .map((path) => `typeof import(${JSON.stringify(toImportPath(path))})`)
      .join(" & ")
    : null;
  // Only augment GlobalProps (interface merge). Cloudflare.Exports is a type
  // alias derived from MainModule + durableNamespaces — redeclaring it would
  // duplicate-identifier against workers-types.
  const source = mainModuleType
    ? `declare namespace Cloudflare {
  interface GlobalProps {
    mainModule: ${mainModuleType};
    durableNamespaces: ${durableUnion};
  }
}
`
    : `declare namespace Cloudflare {
  interface GlobalProps {
    durableNamespaces: ${durableUnion};
  }
}
`;
  return source;
}
